/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Tile layer for Leaflet that shows styled traffic tubes using
 * <a href="https://developer.tomtom.com/online-traffic">online traffic data</a>
 * from TomTom.
 *
 * @class TomTomTrafficLayer
 * @extends L.TileLayer
 * @module Map
 * @namespace L
 * @constructor
 * @param {Object} [options] It accepts all the options that
 *     <a href="http://leafletjs.com/reference-${leaflet.version}.html#tilelayer-options">Leaflet's TileLayer</a>
 *     allows.
 *     The additional options, which are TomTom specific, are described below.
 * @param {String} [options.key] API key that can be obtained from
 *     <a href="http://developer.tomtom.com">TomTom's developer portal</a>.
 *     This is a key for the traffic services.
 * @param {"s1"|"s2"|"s3"|"night"} [options.style="night"] The traffic layer style to use
 * @param {Number} [options.opacity=0.8] The traffic incidents layer's opacity set by default to 80%.
 *     A floating point value between `0` and `1` have to be used, where `1` means no transparency.
 * @param {Boolean} [options.noRefresh] Disables periodic updates of traffic layers.
 * @param {Number} [options.refresh=30000] The traffic incidents information changes and needs to be updated
 *     periodically. By default, it is refreshed every 30 seconds. This parameter's value represents the time
 *     in milliseconds between each update interval. The value must be 30000 or greater.
 *
 */
/**
 * Name of traffic layer. It can be used to differentiate layers.
 * @property name
 * @default "traffic"
 * @type String
 */

/* jshint nomen:false */
define(['leaflet',
    'security',
    'http',
    'endpoints',
    './trafficRefresher',
    'requester/analytics',
    './tileSetTransform',
    'services/utils'],
function(L,
    security,
    http,
    endpoints,
    trafficRefresher,
    analytics,
    tileSetTransform,
    Utils
) {
    'use strict';

    var trafficStyles = ['s1', 's2', 's3', 'night'];

    function getTrafficStyle(trafficLayer) {
        var style = 'night',
            i;
        if (Utils.isString(trafficLayer)) {
            for (i = 0; i < trafficStyles.length; i += 1) {
                if (trafficStyles[i] === trafficLayer.toLowerCase()) {
                    return trafficStyles[i];
                }
            }
        }
        return style;
    }

    function handleSubdomains(options) {
        if (Utils.isString(options.subdomains)) {
            options.subdomains = options.subdomains.split('');
        }
    }

    function loadAnimation() {
        var opacity = 'opacity',
            back = this._bgBuffer;
        back.style[L.DomUtil.TRANSITION] = opacity + ' 10';
        back.style[opacity] = 0.1;
        this._tileContainer.style[opacity] = this.options.opacity;
    }

    var emptyTileUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAB9JREFUGBntwQENAAAAwiD7p34ON2AAAAAAAAAAAOcCIQAAAfWivQQAAAAASUVORK5CYII=' //eslint-disable-line

    L.TomTomTrafficLayer = L.TileLayer.extend({
        options: {
            attribution: '',
            minZoom: 2,
            maxZoom: 18,
            subdomains: 'abcd',
            reuseTiles: true,
            opacity: 0.8,
            errorTileUrl: emptyTileUrl,
            detectRetina: false,
            trafficModelId: -1,
            refresh: 30000,
            zIndex: 230
        },
        /**
         * Name of traffic layer. It can be used to differentiate layers.
         * @property name
         * @default "traffic"
         * @type String
         */
        name: 'traffic',
        initialize: function(options) {
            var key;
            options = L.setOptions(this, options);
            if (options.bounds) {
                options.bounds = L.latLngBounds(options.bounds);
            }
            security.setKey('services/traffic', options.key);
            key = security.getKey('services/traffic');
            options.accessToken = key;
            this._requestUrl = http.protocol() + '://' + endpoints.trafficLayer +
                '?t={trafficModelId}' + (key ? '&key={accessToken}' : '');
            this._url = this._requestUrl;
            options.style = getTrafficStyle(options.style);
            handleSubdomains(options);
            options.tileSize = options.detectRetina && L.Browser.retina ? 512 : 256;
            if (options.tileSize === 512) {
                options.zoomOffset -= 1;
                options.minZoom = options.minZoom > 0 ? options.minZoom - 1 : 0;
            }
            this.setOpacity(options.opacity);

            tileSetTransform.fixTileScale.call(this);
        },
        onAdd: function(map) {
            L.TileLayer.prototype.onAdd.call(this, map);
            if (this._animated) {
                this.on('load', loadAnimation);
            }
            this._updateOpacity();
            this.trafficRefresherIntervalId =
                trafficRefresher.addRefresherWithModelId(undefined, this.setTrafficModelId, this);
        },
        onRemove: function(map) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            L.TileLayer.prototype.onRemove.call(this, map);
        },
        updateOptions: function(options) {
            trafficRefresher.remove(this.trafficRefresherIntervalId);
            this.trafficRefresherIntervalId =
                trafficRefresher.addRefresherWithModelId(options, this.setTrafficModelId, this);
            L.setOptions(this, options);
        },
        setTrafficModelId: function(trafficModelId) {
            if (this.options.trafficModelId !== trafficModelId) {
                this.options.trafficModelId = trafficModelId;
                this.redraw();
            }
        },
        createTile: function(coords, done) {
            var tile;
            if (this.options.trafficModelId === -1) {
                tile = document.createElement('img');
                tile.src = emptyTileUrl;
                done(null, tile);
                return tile;
            }
            return analytics.customCreateTile(coords, done, this);
        }
    });

    L.tomTomTrafficLayer = function(options) {
        return new L.TomTomTrafficLayer(options);
    };

    return L.tomTomTrafficLayer;
});



// WEBPACK FOOTER //
// ./display/layers/trafficLayer.js